import { useEditorRoster } from "@/payroll/editor/query";
import { RulesRosterSkeleton } from "@/payroll/editor/rules-roster-skeleton";
import { editorError } from "@/payroll/editor/state";
import { RosterTable } from "./roster-table";
/**
 * Who the pay rules pay, and what they read about each person.
 *
 * The agent can change a roster as well as the rules — a rate that belongs to
 * one person belongs here, not in the script — and until this view existed that
 * change happened with nothing on screen to show it. Columns the rules do not
 * read are still shown, in lighter ink: they are part of the roster the owner
 * knows, and hiding them would make the view disagree with the roster editor.
 */
export const RulesRoster = ({
  businessId,
  workspaceId,
  active,
}: {
  businessId: string;
  workspaceId: string;
  active: boolean;
}) => {
  const query = useEditorRoster(businessId, workspaceId, active);
  const roster = query.data;
  if (query.isPending) return <RulesRosterSkeleton />;
  if (query.isError)
    return (
      <p role="alert" className="p-4">
        Could not load the roster. {editorError(query.error)}
      </p>
    );
  if (!roster) return <RulesRosterSkeleton />;
  if (!roster.present)
    return (
      <section className="space-y-2 p-4">
        <h2 className="font-semibold">Roster</h2>
        <p className="text-secondary-text">
          This business does not have a published roster yet, so the pay rules
          read everything from the script.
        </p>
      </section>
    );
  return <RosterTable roster={roster} />;
};
